import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { brandingApi } from '../lib/api';
import { useAuth } from './AuthContext';

const BrandingContext = createContext(null);

export const BrandingProvider = ({ children }) => {
  const { user } = useAuth();
  const [branding, setBranding] = useState({ app_name: 'SpillConsult EMS', logo_file_id: null });
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = user ? await brandingApi.get() : await brandingApi.getPublic();
      setBranding(data);
    } catch (e) {
      // ignore
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.user_id]);

  const value = useMemo(() => ({ branding, setBranding, refresh, loading }), [branding, loading, refresh]);

  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => {
  const ctx = useContext(BrandingContext);
  if (!ctx) throw new Error('useBranding must be used within BrandingProvider');
  return ctx;
};
